import React, { useState, useEffect } from 'react';
import { checkMenu } from '../Utils/Common';
import DefaultLayout from '../component/DefaultLayout';
import Footer from '../component/Footer';
import Api from '../config/Api';

import { AiOutlinePlus, AiFillEdit, AiFillDelete, AiFillPicture, AiOutlineClose } from 'react-icons/ai'
import { GoVerified ,GoUnverified } from "react-icons/go";
import { CgBlock, CgUnblock } from "react-icons/cg";
import { SiMinutemailer } from "react-icons/si";

import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Card from 'react-bootstrap/Card';
import Navbar from 'react-bootstrap/Navbar';
import Form from 'react-bootstrap/Form';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, useHistory } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import { FiSearch } from "react-icons/fi";
import moment from 'moment'
import { confirm } from "react-confirm-box";
import { defaultConf } from "../config/DefaultConf";
import Modal from 'react-bootstrap/Modal';
import Stack from 'react-bootstrap/Stack';
import dayjs from "dayjs";
import 'bootstrap/dist/css/bootstrap.min.css';

function Projects() {
  const history = useHistory()
  const [dataList, setDataList] = useState([])
  const [fileList, setFileList] = useState([])
  const [fullscreen, setFullscreen] = useState(true);

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [pageFile, setPageFile] = useState(1);
  const [limitFile, setLimitFile] = useState(15);
  const [pagesFile, setPagesFile] = useState(0);
  const [rowsFile, setRowsFile] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [query, setQuery] = useState("");
  const newDate = new Date(Date.now() + (1*24*60*60*1000));
  const filePath = defaultConf.uploadUrl;
  const [modalShow, setModalShow] = React.useState(false);
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedType, setSelectedType] = useState("");
  
  useEffect(() => {
    getDataList()        
  }, [page, keyword]);

  const getDataList = async () => {
    await Api().get(`projects?filter=${keyword}&fields=projectName,clientName,country,city,district,address,details&page=${page}&limit=${limit}`)
    .then((response) => response)
    .then((data) => {
      const listData = data.data;
      setDataList(listData.docs);
      setPage(listData.page);
      setPages(listData.totalPages);
      setRows(listData.totalDocs);
    })
    .catch((err) => {
    })
  }

  const getFileList = async (pageNum=pageFile, limitNum=limitFile) => {
    await Api().get(`files?page=${pageNum}&limit=${limitNum}`)
    .then((response) => response)
    .then((responseFiles) => {
      console.log(responseFiles)
      const listFiles = responseFiles.data;
      setFileList(listFiles.docs);
      setPageFile(listFiles.page);
      setPagesFile(listFiles.totalPages);
      setRowsFile(listFiles.totalDocs);
      setModalShow(true)
    })
    .catch((err) => {
    })
  }

  const changePage = ({ selected }) => {
    setDataList([])
    setPage(selected+1);
    // getDataList();
  }

  const changePageFile = ({ selected }) => {
    console.log(selected)
    setFileList([])
    setPageFile(selected+1);
    getFileList(selected+1);
  }

  const searchData = (e) => {
    console.log(e)
    e.preventDefault();
    setPage(0);
    setKeyword(query);
  }

  const handleDelete = async (e) => {
    e.preventDefault();
    const id = e.target.attributes.getNamedItem("data-id").value
    const payload = {
      isDeleted: true,
    };
    const confirm_action = await confirm("Anda yakin ingin menghapus data ini?");
    if (confirm_action) {
      await Api().patch(`projects/${id}`, payload)
      .then((response) => response)
      .then((res) => {
        if( res.status === 200 ){
          getDataList()
        }
      })
      .catch((err) => {
          
      });
    }
  }

  const handleSetIsBanner = async (e) => {
    e.preventDefault();
    const id = e.target.attributes.getNamedItem("data-id").value
    const isBanner = e.target.attributes.getNamedItem("data-is-banner").value
    var confirm_action_title = ""
    if( isBanner )
    {
      confirm_action_title = "Anda yakin menghapus project ini menjadi Home Banner?"
    }
    else
    {
      confirm_action_title = "Anda yakin project ini menjadi Home Banner?"
    }
    
    const confirm_action = await confirm(confirm_action_title);
    if (confirm_action) {
      await Api().patch(`projects/banner/${id}`, {id: id})
      .then((response) => response)
      .then((res) => {
        console.log(res)
        if( res.status === 200 ){
          getDataList();
        }
      })
      .catch((err) => {
          
      });
    }
  }

  const handleSetImage = async (e) => {
    // e.preventDefault();
    const id = e.target.attributes.getNamedItem("data-id").value
    const type = e.target.attributes.getNamedItem("data-type").value

    const payload = {
      type: "Project",
    };

    if (type === "Banner") {
      payload.coverBanner = id;
    } else {
      payload.thumbnails = id;
    }

    await Api().put(`files/cover/${selectedProject}`, payload)
    .then((response) => response)
    .then((res) => {
      console.log(res)
      if( res.status === 200 ){
        window.location.reload()
      }
    })
    .catch((err) => {
        
    });
  }

  const handleDeleteImage = async (e) => {
    // e.preventDefault();
    const id = e.target.attributes.getNamedItem("data-id").value
    const type = e.target.attributes.getNamedItem("data-type").value

    const payload = {
      type: "Project",
    };

    if (type === "Banner") {
      payload.coverBanner = null;
    } else {
      payload.thumbnails = null;
    }

    await Api().put(`files/cover/${id}`, payload)
    .then((response) => response)
    .then((res) => {
      console.log(res)
      if( res.status === 200 ){
        window.location.reload()
      }
    })
    .catch((err) => {
        
    });
  }

  const handleOpenFiles = async (e) => {
    e.preventDefault();
    const id = e.target.attributes.getNamedItem("data-id").value
    const type = e.target.attributes.getNamedItem("data-type").value
    setSelectedType(type)
    setSelectedProject(id)
    setFullscreen(true)
    getFileList()
  }

  const handleCloseModal = () => {
    setModalShow(false)
    setPageFile(1);
    setPagesFile(0);
    setRowsFile(0);
  }

  return (
    <>
      <div style={{ display: 'flex', height: '100%', direction: 'ltr' }}>
        <DefaultLayout />
        {/* <div className={ getStyles().collapsed === true ? 'content-wrapper collapsed' : 'content-wrapper' }> */}
        <main>
          <div className="content-header">
            <Container fluid>
              <Row className="">
                <Col sm={4}>
                  <h1 className="m-0">Projects</h1>
                </Col>
                <Col sm={2}>
                    { checkMenu('addproject') &&
                        <Link to="addproject"><Button variant="outline-primary" className="btn-upload"><AiOutlinePlus /> Add Project</Button></Link>
                    }
                </Col>
                <Col sm={3}>
                  <Form className="d-flex" onSubmit={searchData}>
                      <Form.Control
                      type="search"
                      placeholder="Search"
                      className="me-2 input-search"
                      aria-label="Search"
                      value={query}
                      onChange={(e) => setQuery(e.target.value)}
                      />
                      <Button type="submit" className="btn-search"><FiSearch /></Button>
                  </Form>
                </Col>
                <Col sm={3}>
                  <div className="date-time float-sm-right">
                      { moment().format('dddd, DD MMMM YYYY') }
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
                
          <div className="content">
            <Container fluid>
              <Row>
                <Col lg={12} style={{padding: '0'}}>
                  <Table striped hover responsive>
                    <thead className="thead">
                      <tr>
                        <th style={{ width: '5%'}} className="text-center">No</th>
                        <th style={{ width: '15%'}} className="text-left">Thumbnail</th>
                        <th style={{ width: '15%'}} className="text-left">Category</th>
                        <th style={{ width: '35%'}} className="text-left">Details</th>
                        <th style={{ width: '35%'}} className="text-left">Descriptions</th>
                        <th style={{ width: '5%'}} className="text-left">Progress</th>
                        {/* <th style={{ width: '5%'}} className="text-left">Is Banner</th> */}
                        <th style={{ width: '5%'}} className="text-left"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        dataList.map((item, i) => (
                          <tr key={i}>
                            <td className="text-center">
                                {page === 1 ?
                                    i+1 : ( limit * (page-1) ) + (i+1)
                                }
                            </td>
                            <td className="text-left">
                              {item.thumbnails === null || typeof item.thumbnails === 'undefined' ?
                                <Button type="button" onClick={handleOpenFiles} data-id={item._id} data-type="Thumbnails">Set Thumbnail</Button>
                                :
                                <>
                                  <img src={filePath + item.thumbnails.uploadFile} width="200" /><br /><br />
                                  <Button type="button" onClick={handleOpenFiles} data-id={item._id} data-type="Thumbnails">Change Thumbnail</Button>
                                </>
                              }
                              <br />
                              <br />
                              <br />
                              {item.coverBanner === null || typeof item.coverBanner === 'undefined' ?
                                <Button type="button" onClick={handleOpenFiles} data-id={item._id} data-type="Banner">Set Banner</Button>
                                :
                                <>
                                  <img src={filePath + item.coverBanner.uploadFile} width="200" /><br /><br />
                                  <Button type="button" onClick={handleOpenFiles} data-id={item._id} data-type="Banner">Change Banner</Button>
                                </>
                              }
                              
                            </td>
                            <td className="text-left">
                              {item.categoryId.name}
                            </td>
                            <td className="text-left">
                              Project Name : {item.projectName} <br />
                              Client Name : {item.clientName} <br />
                              Duration : {item.duration} <br />
                              Total Budget : IDR {item.totalBudget.toLocaleString('en-US')} <br />
                              Approx Value : {item.approxValue} <br />
                              {item.startDate !== null || item.endDate !== null ?
                                <span>Timeline : {dayjs(item.startDate).format("DD/MM/YYYY")} - {dayjs(item.endDate).format("DD/MM/YYYY")}</span>
                              :
                                <span></span>  
                              }<br />
                              Address : {item.address}, {item.district},  {item.city} - {item.country}
                            </td>
                            <td className="text-left">
                              {item.descriptions}
                            </td>
                            <td className="text-left">{item.totalProgress} %</td>
                            {/* <td className="text-left">
                              <Link to="#" onClick={handleSetIsBanner} data-id={item._id} data-is-banner={item.isBanner}><AiFillPicture /> {item.isBanner === true ? "Yes" : "No"}</Link>
                            </td> */}
                            <td className="text-left">
                              <NavDropdown title="Action" className='' id="basic-nav-dropdown">
                                <NavDropdown.Item href="#" onClick={handleOpenFiles} data-id={item._id} data-type="Banner"><AiFillPicture /> {item.coverBanner === null || typeof item.coverBanner === 'undefined' ? "Set Home Banner" : "Change Home Banner"}</NavDropdown.Item>
                                
                                <NavDropdown.Item href="#" onClick={handleOpenFiles} data-id={item._id} data-type="Thumbnails"><AiFillPicture /> {item.thumbnails === null || typeof item.thumbnails === 'undefined' ? "Set Image Content" : "Change Image Content"}</NavDropdown.Item>
                                { checkMenu('galleryproject') && 
                                    <NavDropdown.Item href={ "galleryproject/" + item._id }><AiFillPicture /> Gallery</NavDropdown.Item>
                                }
                                { checkMenu('editproject') && 
                                    <NavDropdown.Item href={ "editproject/" + item._id }><AiFillEdit /> Edit</NavDropdown.Item>
                                }
                                { checkMenu('deleteproject') && 
                                    <NavDropdown.Item href="#" onClick={handleDelete} data-id={item._id}><AiFillDelete /> Delete</NavDropdown.Item>
                                }
                              </NavDropdown>
                              </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </Table>
                  <Card className="content-list">
                    <Card.Footer>
                      <Row>
                        <Col lg={3}>
                          <p>Total Data: {rows} Page: {rows ? page : 0} of {pages}</p>
                        </Col>
                        <Col lg={9}>
                          <nav
                            className="pagination float-sm-right"
                            key={rows}
                            role="navigation"
                            aria-label="pagination"
                          >
                            <ReactPaginate
                              previousLabel={"Prev"}
                              nextLabel={"Next"}
                              pageCount={pages}
                              onPageChange={changePage}
                              containerClassName={"pagination-list pagination"}
                              pageLinkClassName={"pagination-link page-link"}
                              previousLinkClassName={"pagination-previous page-link"}
                              nextLinkClassName={"pagination-next page-link"}
                              activeLinkClassName={"pagination-link is-current"}
                              disabledLinkClassName={"pagination-link is-disabled"}
                              activeClassName={"active"}
                              pageClassName={"page-item"}
                            />
                          </nav>
                        </Col>
                      </Row>
                    </Card.Footer>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </main>
      </div>
      <Footer />

      <Modal 
        show={modalShow} 
        fullscreen={fullscreen} 
        onHide={handleCloseModal}
        dialogClassName="modal-full-custom"
        scrollable={fullscreen}
      >
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>
            {selectedType === "Banner" ? "Set Home Banner" : "Set Thumbnail"}
          </Modal.Title>
        </Modal.Header>
        {/* <Modal.Header style={{display: "block"}}>
        </Modal.Header> */}
        <Modal.Body>
          <Container fluid>
            <Row xs={5} md={5} lg={5} className="g-2">
              {
                fileList.map((item, i) => (
                  <Col key={i}>
                    <Card>
                      <Card.Img variant="top" src={filePath + item.uploadFile} />
                      
                      <Card.Body>
                        <Button variant="primary" data-id={item._id} data-type={ selectedType === "Banner" ? "Banner" : "Thumbnails" } onClick={handleSetImage}>Choose This</Button>
                      </Card.Body>
                    </Card>
                  </Col>
                ))
              }
            </Row>
          </Container>
          
        </Modal.Body>
        <Modal.Footer>
          <Container fluid>
            <Row>
              <Col lg={3} md={4}>
                <p>Total Data: {rowsFile} Page: {rowsFile ? pageFile : 0} of {pagesFile}</p>
              </Col>
              <Col lg={9} md={8}>
                <nav
                  className="pagination float-sm-right"
                  key={rowsFile}
                  role="navigation"
                  aria-label="pagination"
                >
                  <ReactPaginate
                    previousLabel={"< Prev"}
                    nextLabel={"Next >"}
                    pageCount={pagesFile}
                    onPageChange={changePageFile}
                    containerClassName={"pagination-list pagination"}
                    pageLinkClassName={"pagination-link page-link"}
                    previousLinkClassName={"pagination-previous page-link"}
                    nextLinkClassName={"pagination-next page-link"}
                    activeLinkClassName={"pagination-link is-current"}
                    disabledLinkClassName={"pagination-link is-disabled"}
                    activeClassName={"active"}
                    pageClassName={"page-item"}
                  />
                </nav>
              </Col>
            </Row>
          </Container>
        </Modal.Footer>
      </Modal>
    </>
  )
}
export default Projects
